import { Component, OnInit } from '@angular/core';
import { Location } from "@angular/common";
import { UserService } from '../../services/user.service';
import { LoginService } from '../../services/login.service';
import { DataService } from "../../services/data.service";

import { map, mergeMap, switchMap, tap } from 'rxjs/operators';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { ProjectService } from 'src/app/services/project.service';
import { AppConfig } from '../../../app/app.config';
import { TranslateService } from '@ngx-translate/core';
import { TranslationLoaderService } from 'src/app/services/translate-loader.service';
import { Title } from '@angular/platform-browser';
import { of } from 'rxjs';
import { stat } from 'fs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmSentComponent } from '../modals/confirm-sent/confirm-sent.component';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserComponent implements OnInit {

  public sidebarCollapsed: boolean = false;
  public isCollapsedManagement = true;
  public isUserManager = false;
  public activeItem = 1;
  public name: string;
  public provinceIcon;
  public cityIcon;
  public oldWebSitePages = [
    '/reports',
    '/trips',
    '/settings/profile',
    '/management/map',
    '/management/report',
    '/management/trip',
    '/management/projects'
  ];
  public editablePages = [
    '/settings/profile',
    '/management/map',
  ];
  public isVisibleSwitchBtn = false;
  public isEditable = false;
  public projectName = environment.projectName
  public refreshLangDropdown: boolean = false;
  constructor(
    private userService: UserService,
    private loginService: LoginService,
    private dataService: DataService,
    private projectService: ProjectService,
    private router: Router,
    private translationService: TranslationLoaderService,
    private translate: TranslateService,
    private config: AppConfig,
    private title: Title,
    private location: Location,
    private modalService: NgbModal,
  ) {
    const baseUrl = location.path();
    if (this.oldWebSitePages.indexOf(baseUrl) > -1) {
      this.isVisibleSwitchBtn = true;
    }
    if (this.editablePages.indexOf(baseUrl) > -1) {
      this.isEditable = true;
    }
  }

  get lang(): string {
    return this.translate.currentLang;
  }

  set lang(value: string) {
    localStorage.setItem('user_lng', value);
    this.translate.use(value);
    this.translationService.getTranslation(value);
  }

  ngOnInit() {
    this.refreshLangDropdown = true;
    this.sidebarCollapsed = JSON.parse(localStorage.getItem('sidebarCollapsed') || 'false');
    this.isUserManager = this.userService.project.role == 'MAIN_PROJECT_MANAGER';
    this.userService.getUserInfo().subscribe(user => this.name = user!.attributes!.firstName);

    // Get province logo and city logo
    const project = JSON.parse(localStorage.getItem('project_id'));
    this.translationService.getTranslation(this.lang);

    this.dataService.getProjectIcon1(project.projectID.id)
      .pipe(
        map(img => {
          return Object.assign(project, { image: img && img.id });
        }
        ),
        tap(pr => {
          if (pr.image) this.provinceIcon = { 'background-image': 'url(' + `${this.config.getHost()}/api2/public/image?image_id=${pr.image}&dimension=250` + ')' }
        }),
        switchMap(project => {
          return this.dataService
            .getProjectIcon2(project.projectID.id)
            .pipe(
              map(img => Object.assign(project, { image: img && img.id })),
              tap(pr => {
                if (pr.image) this.cityIcon = { 'background-image': 'url(' + `${this.config.getHost()}/api2/public/image?image_id=${pr.image}&dimension=250` + ')' }
              })
            )
        })
      )
      .subscribe();

    this.userService.getZeusStatus().subscribe(state => {
      localStorage.setItem('zeus_status', state);
    })

    this.projectService.ProvinceLogoGet().subscribe(state => {
      console.log("province", state);
      this.provinceIcon = state.provinceIcon;
    });

    this.projectService.CityLogoGet().subscribe(state => {
      console.log("city", state);
      this.cityIcon = state.cityIcon;
    });

    this.dataService.getProjectData(project.projectID.id).pipe(
      mergeMap(project => {
        localStorage.setItem('project_location', project.center ? project.center.coordinates : project.center);
        return (project.parentID && project.parentID.id)
          ? of(project.parentName + ' / ' + project.name)
          : of(project.name);
      })
    ).subscribe(name => {
      this.title.setTitle(name + ' - ' + this.projectName);
    })

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (event.url && this.oldWebSitePages.indexOf(event.url) > -1) {
          this.isVisibleSwitchBtn = true;
        }
        else {
          this.isVisibleSwitchBtn = false;
        }

        if (event.url && this.editablePages.indexOf(event.url) > -1) {
          this.isEditable = true;
        } else {
          this.isEditable = false;
        }
      }
    })
  }

  openOldSite() {
    if (this.isEditable) {
      const confirm = this.modalService.open(ConfirmSentComponent);
      confirm.componentInstance.data = {
        text: 'Are you sure you want to discard changes?',
        header: 'Discard changes'
      };
      confirm.result.then(ok => {
        location.replace(this.config.getOldUrl());
      });
    } else {
      location.replace(this.config.getOldUrl());
    }
  }

  sidebarToggle() {
    this.sidebarCollapsed = !this.sidebarCollapsed;
    localStorage.setItem('sidebarCollapsed', JSON.stringify(this.sidebarCollapsed));
  }

  onManagementClick() {
    this.isCollapsedManagement = !this.isCollapsedManagement;
  }

  logout() {
    this.loginService.logout().subscribe(r => {
      const currentLang = localStorage.getItem('user_lng')
      localStorage.clear();
      localStorage.setItem('user_lng',currentLang)
      this.title.setTitle(this.projectName);
      this.router.navigate(['/', 'login']);
    });
  }
}
